"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.KeySVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var KeySVG = function KeySVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M23.1423 2.27405C23.328 2.09808 23.5742 2 23.83 2H28.83C29.3823 2 29.83 2.44772 29.83 3V8C29.83 8.2648 29.725 8.5188 29.538 8.70627L21.5865 16.6767C22.2621 18.6236 22.3215 20.7378 21.747 22.7284C21.1089 24.9389 19.7283 26.8617 17.8377 28.1728C15.9471 29.4838 13.6623 30.1028 11.3684 29.9255C9.07459 29.7482 6.91205 28.7854 5.24543 27.1993C3.5788 25.6133 2.51004 23.5011 2.21933 21.2188C1.92862 18.9366 2.43376 16.6239 3.64956 14.6707C4.86537 12.7175 6.71747 11.2433 8.89361 10.4966C10.8643 9.82042 12.9915 9.7783 14.9789 10.3669L16.1629 9.18289C16.3505 8.99536 16.6048 8.89 16.87 8.89H19.24V6.53C19.24 5.97772 19.6877 5.53 20.24 5.53H22.64V3.18C22.64 2.90541 22.7529 2.6429 22.9523 2.45405L23.1423 2.27405ZM9.35799 20.3695C9.64366 20.1836 9.97936 20.0896 10.32 20.1V20.15C10.7619 20.1548 11.1848 20.3304 11.5 20.64C11.7332 20.8736 11.892 21.171 11.9563 21.4947C12.0206 21.8184 11.9875 22.1539 11.8613 22.4589C11.735 22.7638 11.5212 23.0245 11.2469 23.208C10.9726 23.3916 10.6501 23.4897 10.32 23.49C10.1005 23.492 9.88277 23.4497 9.68 23.3655C9.47723 23.2813 9.29356 23.157 9.14001 23C8.88883 22.7697 8.71414 22.468 8.63941 22.1355C8.56467 21.8029 8.59346 21.4555 8.72191 21.1398C8.85036 20.8242 9.07232 20.5553 9.35799 20.3695Z",
    stroke: "none"
  }));
};
exports.KeySVG = KeySVG;
KeySVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(KeySVG);
exports.default = _default;